// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6196) return "static/chunks/6196-3e3db83f18c5952b.js";
	if (chunkId === 3618) return "static/chunks/3618-11275be5c8ef81cb.js";
	if (chunkId === 7171) return "static/chunks/7171-a746fa65da0b9f90.js";
	if (chunkId === 5706) return "static/chunks/5706-98631518d7f11f76.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8229 ? "9da6db1e" : chunkId) + "." + {"1723":"c82ecc30d704e63d","7369":"4359d2ffe1269464","8229":"12639115766fcb65","8777":"ca780dfbabfff785"}[chunkId] + ".js";
};